<template>
  <div class="item" :class="'label__' + item.labelPosition">
    <span class="label">{{ item.label }} :</span>
    <span class="showdata"
      >{{ item.prepend || '' }} {{ labels.dynamicValue }} {{ item.append || '' }}</span
    >
  </div>
</template>
<script>
import { ft } from '../../../lib/utils.js';

const LABELS = {
  dynamicValue: ft('i18n_common_dynamic_value', '动态数值'),
  label: ft('i18n_common_label', '标签')
};

// 属性信息展示卡 - 单条模式
export default {
  name: 'item-normal',
  props: {
    item: {
      type: Object,
      default: function () {
        return {
          labelPosition: 'left',
          label: LABELS.label,
          props: 'myprops',
          valueDefault: LABELS.dynamicValue,
          prepend: null,
          append: null
        };
      }
    },
    labels: {
      type: Object,
      default: function () {
        return LABELS;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.label__top {
  span.label {
    display: block;
  }
  span.showdata {
    display: block;
    margin-left: 10px;
  }
}
.label__left {
  span.label {
    display: inline-block;
    width: 120px;
  }
  span.showdata {
    display: inline-block;
    margin-left: 10px;
  }
}
</style>
